import React, { useEffect } from 'react';

import { Tooltip, HStack, Text } from '@chakra-ui/react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { useStateList } from 'react-use';

import { Icon, MultiCheckbox } from 'components';
import { PermissionTypes } from 'enums/types';

interface MultiCheckboxProps extends UseFormReturn {
  value: PermissionTypes
  id: string
  editable: boolean
}

const modes = {
  [PermissionTypes.Allow]: {
    color: 'primary.default',
    family: 'fas',
  },
  [PermissionTypes.Related]: {
    color: 'system.warn.default',
    family: 'fas',
  },
  [PermissionTypes.Disallow]: {
    color: 'gray.600',
    name: 'square',
    family: 'far',
  },
  [PermissionTypes.Blocked]: {
    color: 'gray.100',
    name: 'square',
    family: 'fas',
  },
};

export default function Rules({
  control, setValue, value, id, editable,
}: MultiCheckboxProps) {
  const { state, next, setState } = useStateList(
    Object.values(PermissionTypes).filter((type) => type !== PermissionTypes.Blocked),
  );
  useEffect(() => {
    if (value !== PermissionTypes.Blocked) {
      setState(value);
    }
  }, [value]);

  useEffect(() => {
    if (value !== PermissionTypes.Blocked) {
      setValue(id, state);
    } else {
      setValue(id, PermissionTypes.Blocked);
    }
  }, [state]);

  return (
    <HStack>
      <Controller
        control={control}
        name={id}
        render={({ field }) => (
          <MultiCheckbox
            {...field}
            onClick={next}
            editable={editable}
            modes={modes}
            isDisabled={value === PermissionTypes.Blocked}
          />
        )}
      />
      <Tooltip
        hasArrow
        color="gray.600"
        bg="gray.50"
        label="Somente a qual está vinculado">
        <Text>
          <Icon
            hidden={state !== PermissionTypes.Related}
            name="question-circle"
          />
        </Text>
      </Tooltip>
    </HStack>
  );
}
